import React, { useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import ActivationCodeInput from './ActivationCodeInput';
import { ActivationCodes, AppSettings } from '../../../globals/interfaces';
import Icon from '../../../components/custom/Icon';
import _ from 'lodash';
import Settings from './Settings';
import { safeJSON } from '../../../utils';


interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedItem: ActivationCodes | undefined;
    activateCode: (code: string, settings: AppSettings, type: string) => Promise<void>;
}

export default function ModalActivate({
    modal,
    setModal,
    selectedItem,
    activateCode
}: Props) {

    // @ts-ignore
    const type = safeJSON(selectedItem?.device_info).type;

    const [inputCode, setInputCode] = useState('');
    const validCode = inputCode === selectedItem?.code;
    const renderInvalid = inputCode.length === 6 && !validCode;
    const [settings, setSettings] = useState<AppSettings>({});

    const toggle = () => setModal(!modal);

    if (!selectedItem) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Activate Device {type && `(${type})`}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <ActivationCodeInput
                    onChange={setInputCode}
                    renderInvalid={renderInvalid}
                />
                {
                    validCode && (
                        <Settings 
                            settings={settings}
                            setSettings={setSettings}
                            type={type}
                        />
                    )
                }
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={true}>
                        <h6>{validCode ? 'Ready for Activation' : 'Code must match the TV'}</h6>
                        {
                            validCode ? (
                                <ActionIcon
                                    type={'check'}
                                    onClick={() => activateCode(inputCode, settings, type)}
                                />
                            ) : (
                                <Icon loading={true} size={14} />
                            )
                        }
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;